import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted'
import HelpRounded from '@material-ui/icons/HelpRounded'
import PortfolioTableMobile from '../components/PortfolioTableMobile'
import BFTabs from '../components/Tabs/BFTabs'
import BFTab from '../components/Tabs/BFTab'
import EmptyDataIcon from '../assets/images/noavailable.png'
import PortfolioTodayMobile from '../containers/PortfolioTodayMobile'
import PortfolioLastWeekMobile from '../containers/PortfolioLastWeekMobile'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { getCookie, setCookieHelper } from '../ultils/cookie'
import { userService } from '../services/users.services'
import { EXPIRED_SECOND } from '../constants/Cookie'
import portfolioIcon from '../assets/images/portfolio-icon.svg'
import {
  HOME_PATHNAME,
  PORTFOLIO_HOME_PATHNAME,
  PORTFOLIO_LAST_WEEK_PATHNAME,
  PORTFOLIO_SINGLE_PATHNAME,
} from '../constants/RoutePathName'
import { clearD3Tips } from '../ultils/dataUtil'
import SearchBoxCommon from '../components/SearchBoxCommon'
// import companySearchList from '../data/mock/ticker-data/companies'
import ResponsiveArticle from '../components/ResponsiveArticle'
import PortfolioTooltipModal from '../components/PortfolioTooltipModal'
import { RISK_TYPE } from '../ultils/chart-d3-utils'

const useStyles = makeStyles({
  container: {
    padding: '0px 20px',
  },
  toolbar: {
    padding: '20px 55px 0px 55px',
  },
  pageTitle: {
    flex: '1 1 100%',
  },
  filterContainer: {
    width: 200,
  },
  toolTip: {
    color: '#8c8c8c',
    fontSize: '1.8rem',
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  subTitle: {
    marginBottom: 15,
    fontSize: 10,
  },
  portfolioTable: {
    backgroundColor: '#fff',
    padding: '20px 25px',
    border: '1px solid #DFE4EB',
    marginTop: '40px',
    borderRadius: 5,
    marginBottom: 35,
  },
  greet: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '22px',
    color: '#181818',
  },
  title: {
    fontWeight: 400,
    fontSize: 20,
    lineHeight: '24.2px',
    color: '#1B3963',
  },
  headPage: {
    height: '60px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 14,
  },
  emptyBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '213px 0px',
  },
  emptyIcon: {
    marginBottom: 23,
  },
  noavailableText: {
    fontSize: 24,
    lineHeight: '24px',
    fontWeight: 600,
    color: '#5E5E5E',
  },
  legendWrapper: {
    width: '200px',
  },
  tabsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchCommonContainer: {
    width: 250,
    marginLeft: 14,
  },
  tabsLabel: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    color: '#474747',
    paddingRight: '16px',
  },
  spinnerContainer: {
    width: '100%',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  portfolioListContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#1B3963',
    width: 130,
    height: 40,
    borderRadius: 3,
    marginLeft: 12,
    cursor: 'pointer',
  },
  portfolioListTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    color: '#FFFFFF',
    marginLeft: 2,
  },
  FormatListBulletedIcon: {
    color: 'white',
    width: 22,
  },

  pMobileControlCombo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 20,
  },
  pMPortfolioTitle: {
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 400,
    color: '#1B3963',
    marginBottom: 5,
  },
})

const getToggleValue = (pathname: string) => {
  switch (pathname) {
    case HOME_PATHNAME:
      return 0
      break
    case PORTFOLIO_HOME_PATHNAME:
      return 0
      break
    case PORTFOLIO_SINGLE_PATHNAME:
      return 0
      break
    case PORTFOLIO_LAST_WEEK_PATHNAME:
      return 1
      break
    default:
      return 0
  }
}

const PortfolioPageMobile = (props: any) => {
  const history = useHistory()
  const classes = useStyles()
  const {
    state,
    getTickersOnlyInPortfolio,
    getAllTickersInUniverse,
    changeSelectedTab,
    changeSelectedRiskTab,
    cleanUp,
  } = useContext(PortfolioContext)
  const [selectedTab, setSelectedTab] = useState(state.selectedTab)
  const [selectedRiskTypeTab, setSelectedRiskTypeTab] = useState(
    state.selectedRiskTypeTab,
  )
  const [recent, setRecent] = useState<any>([])
  // const companies = useMemo(() => [...recent, ...companySearchList], [
  //   recent,
  //   companySearchList,
  // ])
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const handleClickOpenTooltip = () => {
    setOpenTooltip(true)
  }
  const changeRiskTypeTabView = (
    event: React.ChangeEvent<{}>,
    newValue?: any,
  ) => {
    setSelectedRiskTypeTab(newValue)
    changeSelectedRiskTab(newValue)
  }

  const getAllTickersInUniverses = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInUniverse ||
        (Array.isArray(state?.tickersInUniverse) &&
          state?.tickersInUniverse.length === 0)
      ) {
        getAllTickersInUniverse(userId)
      }
    },
    [state?.tickersInUniverse],
  )

  const getTickersOnlyInPortfolios = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInPortfolio ||
        (Array.isArray(state?.tickersInPortfolio) &&
          state?.tickersInPortfolio.length === 0)
      ) {
        getTickersOnlyInPortfolio(userId)
      }
    },
    [state?.tickersInPortfolio],
  )

  useEffect(() => {
    clearD3Tips()
    if (!getCookie('userId') && getCookie('accessToken')) {
      userService
        .getUser(getCookie('email'))
        .then(res => {
          setCookieHelper('userId', res.data, EXPIRED_SECOND)
          getAllTickersInUniverses(res.data)
          setCookieHelper(
            'implied_rating_flag',
            res.implied_rating_flag,
            EXPIRED_SECOND,
          )
          getTickersOnlyInPortfolios(res.data)
        })
        .catch(() => {})
    } else {
      getAllTickersInUniverses(getCookie('userId'))
      getTickersOnlyInPortfolios(getCookie('userId'))
    }
  }, [])

  useEffect(() => {
    setSelectedTab(getToggleValue(props.location.pathname))
    changeSelectedTab(getToggleValue(props.location.pathname))
  }, [props.location.pathname])

  const changeTabView = (event: React.ChangeEvent<{}>, newValue?: any) => {
    setSelectedTab(newValue)
    changeSelectedTab(newValue)
    if (newValue === 0) history.push(PORTFOLIO_HOME_PATHNAME)
    else if (newValue === 1) history.push(PORTFOLIO_LAST_WEEK_PATHNAME)
  }

  return (
    <>
      <div className={classes.container}>
        {state.loading && (
          <div className={classes.portfolioTable}>
            <ResponsiveArticle />
          </div>
        )}
        <div className={classes.pMobileControlCombo}>
          <BFTabs size="small" value={selectedTab} onChange={changeTabView}>
            <BFTab size="small" label="Today" value={0} />
            <BFTab size="small" label="Week to Date" value={1} />
          </BFTabs>

          <a href="#portfolioTable">
            <div className={classes.portfolioListContainer}>
              <FormatListBulletedIcon
                className={classes.FormatListBulletedIcon}
              />
              <span className={classes.portfolioListTitle}>Portfolio List</span>
            </div>
          </a>
        </div>
        <div className={classes.pMobileControlCombo}>
          <BFTabs
            size="small"
            value={selectedRiskTypeTab}
            onChange={changeRiskTypeTabView}
          >
            <BFTab size="small" label="Equity Risk" value={RISK_TYPE.EQUITY} />
            <BFTab size="small" label="Credit Risk" value={RISK_TYPE.CREDIT} />
          </BFTabs>
        </div>
        {!state.loading && (
          <>
            {selectedTab === 0 ? (
              <>
                <div className={classes.pMPortfolioTitle}>
                  Portfolio
                  <HelpRounded
                    className={classes.toolTip}
                    key="1"
                    onClick={() => handleClickOpenTooltip()}
                  />
                </div>
                <div className={classes.subTitle}>
                  (Heat-Map of Risk in your Portfolio Companies)
                </div>
                <PortfolioTodayMobile
                  tickers={state.tickersInPortfolio}
                  riskType={selectedRiskTypeTab}
                />
              </>
            ) : (
              <PortfolioLastWeekMobile
                tickers={state.tickersInPortfolio}
                riskType={selectedRiskTypeTab}
              />
            )}
          </>
        )}

        {!state.loading && (
          <div id="portfolioTable" style={{ marginTop: '-30px' }}>
            <PortfolioTableMobile tickers={state.tickersInPortfolio} />
          </div>
        )}
        <PortfolioTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
        />
      </div>
    </>
  )
}

export default PortfolioPageMobile
